import { useContext, useEffect, useState } from "react";
import RegistrarCuenta from '../RegistrarCuenta/RegistrarCuenta';


export const Registrar = () => {
    return(
        <> 
        <RegistrarCuenta/>
        </>
    );


}